module.exports = __webpack_public_path__ + "static/media/the-morning-show-section-header-logo.cfea6f66.jpg";